import { render } from "./AllSegmentGroupsDataBase.vue?vue&type=template&id=798a95dd&scoped=true"
import script from "./AllSegmentGroupsDataBase.vue?vue&type=script&lang=js"
export * from "./AllSegmentGroupsDataBase.vue?vue&type=script&lang=js"

import "./AllSegmentGroupsDataBase.vue?vue&type=style&index=0&id=798a95dd&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798a95dd"]])

export default __exports__